import { SVGIconComponent } from './types';

export const Multiple: SVGIconComponent = ({ className, color, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Type/Multiple" stroke="none" fill="none" fill-rule="nonzero">
      <path
        fill="currentColor"
        d="M19.488 4.536A5.5 5.5 0 0 0 14.358 1H6.5A5.5 5.5 0 0 0 1 6.5v7.857a5.5 5.5 0 0 0 3.536 5.13A5.5 5.5 0 0 0 9.643 23H17.5a5.5 5.5 0 0 0 5.5-5.5V9.643a5.5 5.5 0 0 0-3.512-5.107m-16.916 9.82V6.5A3.924 3.924 0 0 1 6.5 2.57h7.856c1.042 0 2.041.414 2.778 1.151A3.92 3.92 0 0 1 18.286 6.5v7.857c0 1.042-.413 2.04-1.151 2.777a3.92 3.92 0 0 1-2.778 1.152H6.5a3.92 3.92 0 0 1-2.777-1.152 3.92 3.92 0 0 1-1.151-2.777M19.857 6.5a3.93 3.93 0 0 1 1.572 3.143V17.5c0 1.042-.414 2.04-1.151 2.777a3.92 3.92 0 0 1-2.778 1.151H9.643A3.93 3.93 0 0 1 6.5 19.857h7.857a5.5 5.5 0 0 0 5.5-5.5zM6.17 9.513a1.06 1.06 0 1 1 0 2.12 1.06 1.06 0 0 1 0-2.12m4.12 0a1.06 1.06 0 1 1 0 2.12 1.06 1.06 0 0 1 0-2.12m4.119 0a1.06 1.06 0 1 1 0 2.12 1.06 1.06 0 0 1 0-2.12"
      />
    </g>
  </svg>
);
